import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import BlockTypes, { OT_BLOCKS, RESET_COUNTER_BLOCKS, VOID_BLOCKS } from '../../types/BlockTypes';
import { normalizeNode, shouldBeAtomic, shouldBeAtRoot } from '../utils/NormalizationHelper';
import toggleBlock from './commands/toggleBlock';
import isActiveBlock from './queries/isActiveBlock';
import isActiveMark from './queries/isActiveMark';
import isActiveInline from './queries/isActiveInline';
import isAtFirstLineOfBlock from './queries/isAtFirstLineOfBlock';
import isAtLastLineOfBlock from './queries/isAtLastLineOfBlock';
import isAtStartOfBlock from './queries/isAtStartOfBlock';
import isAtEndOfBlock from './queries/isAtEndOfBlock';
import isContinuousBlock from './queries/isContinuousBlock';
import getInContinuousBlock from './queries/getInContinuousBlock';
import isDefaultBlock from './queries/isDefaultBlock';
import isMutableBlock from './queries/isMutableBlock';
import isEmptyBlock from './queries/isEmptyBlock';
import isHeaderBlock from './queries/isHeaderBlock';
import isIndented from './queries/isIndented';
import canChangeDepth from './queries/canChangeDepth';
import documentShouldNotBeEmpty from './normalizers/documentShouldNotBeEmpty';
import otBlocksShouldHaveIds from './normalizers/otBlocksShouldHaveIds';
import shouldNormalizeDepth from './normalizers/shouldNormalizeDepth';
import shouldWrapOrphanBlocks from './normalizers/shouldWrapOrphanBlocks';
import getBlockDepth from '../utils/getBlockDepth';
import generateBlockId from '../utils/generateBlockId';
import isEventInEditor from '../utils/isEventInEditor';
var schema = {
  rules: [{
    match: OT_BLOCKS.map(function (type) {
      return {
        object: 'block',
        type: type
      };
    }),
    nodes: [{
      match: [{
        object: 'inline'
      }, {
        object: 'text'
      }]
    }],
    normalize: function normalize(editor, error) {
      if (error.code === 'child_object_invalid') {
        editor.unwrapNodeByKey(error.child.key);
      }
    }
  }]
};
var DATA = {
  DEPTH: 'data-depth',
  TYPE: 'data-type',
  RESET_COUNTER: 'data-reset-counter'
};
export default (function () {
  var keystrokes = {
    isShiftKeyPressed: false
  };
  return [{
    schema: schema
  }, {
    commands: {
      toggleBlock: toggleBlock
    },
    queries: {
      isActiveBlock: isActiveBlock,
      isActiveMark: isActiveMark,
      isActiveInline: isActiveInline,
      isAtFirstLineOfBlock: isAtFirstLineOfBlock,
      isAtLastLineOfBlock: isAtLastLineOfBlock,
      isAtStartOfBlock: isAtStartOfBlock,
      isAtEndOfBlock: isAtEndOfBlock,
      isContinuousBlock: isContinuousBlock,
      getInContinuousBlock: getInContinuousBlock,
      isDefaultBlock: isDefaultBlock,
      isEmptyBlock: isEmptyBlock,
      isEventInEditor: isEventInEditor,
      isHeaderBlock: isHeaderBlock,
      isMutableBlock: isMutableBlock,
      isIndented: isIndented,
      canChangeDepth: canChangeDepth,
      isShiftKeyPressed: function isShiftKeyPressed() {
        return keystrokes.isShiftKeyPressed;
      }
    }
  }, normalizeNode(VOID_BLOCKS, [shouldBeAtomic]), normalizeNode(BlockTypes.UNSTYLED, [shouldBeAtRoot]), {
    normalizeNode: documentShouldNotBeEmpty
  }, {
    normalizeNode: otBlocksShouldHaveIds
  }, {
    normalizeNode: shouldWrapOrphanBlocks
  }, {
    normalizeNode: shouldNormalizeDepth
  }, {
    onKeyDown: function onKeyDown(event, editor, next) {
      keystrokes.isShiftKeyPressed = event.shiftKey;
      return next();
    },
    onKeyUp: function onKeyUp(event, editor, next) {
      keystrokes.isShiftKeyPressed = event.shiftKey;
      return next();
    },
    renderBlock: function renderBlock(props, editor, next) {
      props.attributes[DATA.DEPTH] = getBlockDepth(props.node);
      props.attributes[DATA.TYPE] = props.node.type;
      props.attributes[DATA.RESET_COUNTER] = RESET_COUNTER_BLOCKS.includes(props.node.type) || undefined;
      return next();
    },
    onCommand: function onCommand(command, editor, next) {
      if (editor.query('isApplyingRemoteChange')) {
        return next();
      }

      if (command.type === 'splitBlock' && editor.value.selection.isSet) {
        next();
        editor.setNodeByKey(editor.value.startBlock.key, {
          data: _objectSpread({}, editor.value.startBlock.data.toJS(), {
            id: generateBlockId()
          })
        });
        return;
      }

      return next();
    },
    onBeforeInput: function onBeforeInput(event, editor, next) {
      if (!editor.value.selection.isSet) {
        event.preventDefault();
        return;
      }

      return next();
    }
  }];
});